import { render, staticRenderFns } from "./footer_payment.vue?vue&type=template&id=1c051c14&"
import script from "./footer_payment.vue?vue&type=script&lang=js&"
export * from "./footer_payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports